

export default {
    computed: {
        ERROR(){
            return {
                MSG: {
                    general_err_msg: '請聯絡系統管理員'   
                },
                LEVEL: {
                    ERROR: 'error',
                    WARN: 'warning',
                    INFO: 'info',
                    SUCCESS: 'success'
                }
            }
        },
    },
    methods: {  
        notify_message(level, title, message) {
            let msg = ''
            if (title) {
                msg += title
            }
            if (message) {
                msg += ', '
                msg += message
            }

            this.$message({
                message: msg,
                duration: 4000,
                type: level
            });
        },
    },
}